import { useState } from 'react';
import { Link } from 'react-router-dom';
import { reviews } from '@/mocks/data';

export default function ReaderReview() {
  const [current, setCurrent] = useState(0);
  const review = reviews[current];

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="relative bg-foreground-900 rounded-2xl overflow-visible p-8 md:p-12 lg:p-16">
          <div className="absolute -top-6 -left-6 hidden lg:block">
            <div className="w-32 h-32">
              <svg viewBox="0 0 128 128" fill="none" className="w-full h-full">
                <path d="M10 118C30 80 50 50 70 30C85 14 100 8 110 8" stroke="oklch(0.48 0.02 36)" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
                <path d="M8 118C28 85 45 58 60 40" stroke="oklch(0.48 0.02 36)" strokeWidth="1" fill="none" strokeLinecap="round"/>
                <path d="M12 118C32 88 48 62 58 48" stroke="oklch(0.48 0.02 36)" strokeWidth="0.7" fill="none" strokeLinecap="round"/>
              </svg>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-10 items-center">
            <div className="w-full lg:w-2/5 -mt-16 lg:-mt-24 lg:-ml-8">
              <div className="rounded-xl overflow-hidden aspect-[2/3] w-full max-w-[280px] mx-auto lg:max-w-none">
                <img
                  src={review.avatar}
                  alt={review.name}
                  title={`韩漫大全读者 ${review.name}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="w-full lg:w-3/5 flex flex-col justify-center">
              <span className="text-7xl md:text-9xl font-serif text-background-100/50 leading-none mb-4">
                &ldquo;
              </span>
              <p className="text-base md:text-lg text-background-50 leading-relaxed mb-6">
                {review.content}
              </p>
              <div className="mb-6">
                <p className="text-sm font-medium text-background-50">{review.name}</p>
                <p className="text-xs text-foreground-400 mt-0.5">{review.level}</p>
              </div>
              <div className="flex items-center gap-3">
                <button
                  onClick={() => setCurrent((current - 1 + reviews.length) % reviews.length)}
                  className="whitespace-nowrap cursor-pointer w-9 h-9 rounded-full border border-background-50/20 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors"
                >
                  <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                </button>
                <button
                  onClick={() => setCurrent((current + 1) % reviews.length)}
                  className="whitespace-nowrap cursor-pointer w-9 h-9 rounded-full border border-background-50/20 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors"
                >
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </button>
                <Link
                  to="/about"
                  className="whitespace-nowrap cursor-pointer bg-accent-400/80 text-foreground-900 px-5 py-2 rounded-full text-sm font-medium hover:bg-accent-400 transition-colors ml-4"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}